import type { OnboardingPlace } from "@-/dev.improve.haniverse.lib.onboarding.state";
import { isLearnMapPathname } from "@-/dev.improve.haniverse.routes.nav.app.learn.map.navigator";

/** Where `pathname` is, as the onboarding sees it: Learn's map, its cards, or another tab. */
export function getOnboardingPlace(pathname: string): OnboardingPlace {
  if (pathname === "/learn" || pathname.startsWith("/learn/")) {
    return isLearnMapPathname(pathname) ? "map" : "cards";
  }
  for (const place of ["browse", "decks", "stats"] as const) {
    if (pathname === `/${place}` || pathname.startsWith(`/${place}/`)) {
      return place;
    }
  }
  return "other";
}

/** The strip tab a place is on: the map and the cards are both Learn's; `null` for `other`. */
export function getOnboardingPlaceTab(place: OnboardingPlace): string | null {
  switch (place) {
    case "cards":
    case "map": {
      return "learn";
    }
    case "browse":
    case "decks":
    case "stats": {
      return place;
    }
    case "other": {
      return null;
    }
  }
}
